import React, { useState, useEffect } from 'react';

const ErrorBoundary = ({ children }) => {
  const [hasError, setHasError] = useState(false);
  const [errorInfo, setErrorInfo] = useState(null);

  const componentDidCatch = (error, errorInfo) => {
    setHasError(true);
    setErrorInfo(errorInfo);
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  };

  useEffect(() => {
    const tryCatchWrapper = async () => {
      try {
        if (children) {
          return;
        }
      } catch (error) {
        componentDidCatch(error, "Simulated ErrorInfo");
      }
    };

    tryCatchWrapper();
  }, [children]);

  if (hasError) {
    return (
      <div style={{ padding: '20px', backgroundColor: '#f8d7da', color: '#721c24', borderRadius: '5px' }}>
        <h2>Oops, something went wrong.</h2>
        <p>Please try again later.</p>
        <details style={{ whiteSpace: 'pre-wrap' }}>
          {errorInfo && errorInfo.toString()}
        </details>
      </div>
    );
  }

  return children;
};

export default ErrorBoundary;
